/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import {accounting} from 'accounting'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import RETAIL from '../BaseComponent/RETAIL'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import {Modal, ModalBody} from 'mdbreact'
import Loader from '../loaders/loader'
import {divIcon} from 'leaflet'
import {renderToStaticMarkup} from 'react-dom/server'
import {Map, Marker, TileLayer, Popup} from 'react-leaflet'

// const MapWithAMarker = withScriptjs(withGoogleMap(props =>
//     <GoogleMap
//         defaultZoom={10}
//         defaultCenter={{ lat: 35.74287570972717, lng: 51.54944953647805 }}
//     >
//         {props.points.map((markers,index)=>(
//             <Marker
//                 key={index}
//                 icon={markers.checked == false ? require('../../image/requestPack.png') : require('../../image/finishPack.png')}
//                 position={{lat: markers.latitude, lng: markers.longitude}}
//                 title={markers.buyerName+'- شماره فاکتور : '+markers.invoiceNum}
//                 checked={markers.checked}
//                 geoTitle={markers.geo.title}
//                 deliveryPackId={markers.deliveryPackId}
//                 invoiceId={markers.invoiceId}
//                 invoiceNum={markers.invoiceNum}
//                 totalAmount={markers.totalAmount}
//                 payableAmount={markers.payableAmount}
//                 Address={markers.address}
//                 buyerName={markers.buyerName}
//                 onClick={()=>props.onMarkerClick(index,markers.deliveryPackId,markers.invoiceId,markers.invoiceNum,markers.totalAmount,markers.payableAmount,markers.address,markers.geoTitle,markers.buyerName)} />
//         ))}
//         <DrawingManager
//             onPolygonComplete={poly => {
//                 const polyArray = poly.getPath().getArray();
//                 let paths = [];
//                 polyArray.forEach(function (path) {
//                     paths.push({lat: path.lat(), lon: path.lng()});
//                     // paths.push(paths[0])
//                     localStorage.setItem('pathPolygon', JSON.stringify(paths))
//                 });

//                 //alert(JSON.stringify(pathseatArrJSONs))
//             }}
//             defaultOptions={{
//                 drawingControl: true,
//                 drawingControlOptions: {
//                     position: google.maps.ControlPosition.TOP_CENTER,
//                     drawingModes: [
//                         google.maps.drawing.OverlayType.POLYGON
//                     ],
//                 },
//                 polygonOptions: {
//                     fillColor: `transparent`,
//                     fillOpacity: 1,
//                     strokeWeight: 5,
//                     clickable: false,
//                     draggable: false,
//                     editable: false,
//                     zIndex: 1,
//                 },
//             }}

//         />
//     </GoogleMap>
// ));

class EditFactorDrivers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      points: [],
      openTable: true,
      custommer: [],
      drivers: [],
      cars: [],
      packId: [],
      editError: '',
      concatData: [],
      data: [],
      listGeo: [],
      finalCustommer: [],
      disabledSelect: false,
      unMatchModal: false,
      failedToDispatchIds: [],
      failedToProcessIds: []
    }
  }

  componentDidMount() {
    this.setState({
      loading: true
    })

    const {dispatchId} = this.props.match.params
    let planId = this.props.match.params.planId
    const {driverId} = this.props.match.params

    http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_GEO}?type=3`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          listGeo: response.data.object
        })
      } else {
        this.setState({
          listGeo: ''
        })
      }
    })

    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_ASSIGNED_BYEDIT
        }?export=true&dispatchId=${dispatchId}&driverId=${driverId}&planId=${planId}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          var custommer = response.data.object.result
          for (let i = 0; i < custommer.length; i++) {
            custommer[i]['checked'] = true
          }

          this.setState({
            custommer: response.data.object.result,
            finalCustommer: response.data.object.result
          })

          http
            .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_UNASSIGNED}?export=true&planId=${planId}`, {})
            .then((response) => {
              // alert(JSON.stringify(response.data));

              if (response.data.error == null) {
                var points = response.data.object.result
                for (let i = 0; i < points.length; i++) {
                  points[i]['checked'] = false
                  points[i]['geoTitle'] = points[i]['geo'].title
                }

                this.setState({
                  points: response.data.object.result,
                  concatData: response.data.object.result.concat(this.state.custommer),
                  loading: false
                })
              } else {
                this.setState({
                  loading: false,
                  points: this.state.points,
                  concatData: this.state.points.concat(this.state.custommer)
                })
                // message.error(response.data.description)
              }
            })
            .catch((error) => {
              this.setState({
                loading: false
              })
              alert(JSON.stringify(error))
            })
        } else {
          this.setState({
            custommer: [],
            loading: false
          })
          // alert(response.data.description)
          // message.error(response.data.description);
        }
      })
      .catch((error) => {
        this.setState({loading: false})
        alert(JSON.stringify(error))
      })
  }

  confirmPoly() {
    if (localStorage.getItem('pathPolygon')) {
      let points = localStorage.getItem('pathPolygon')
      const {driverId} = this.props.match.params
      const dataPoint = {
        planId: this.props.match.params.planId,
        points: JSON.parse(points),
        driverId: driverId
      }

      // alert(JSON.stringify(dataPoint))

      http
        .post(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_POLYGONSEARCH_BYEDIT}`, dataPoint, {})
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error == null) {
            // alert(1)
            localStorage.removeItem('pathPolygon')

            var temp = this.state.finalCustommer
            response.data.object.result.forEach(function(newItem) {
              var found = false
              temp.forEach(function(oldItem) {
                if (newItem.deliveryPackId == oldItem.deliveryPackId) {
                  found = true
                }
              })
              if (found === false) {
                temp.push(newItem)
              }
            })

            this.setState({
              finalCustommer: temp,
              openTable: true
            })

            for (let i = 0; i < this.state.finalCustommer.length; i++) {
              const positionObject = {
                deliveryPackId: this.state.finalCustommer[i].deliveryPackId,
                invoiceId: this.state.finalCustommer[i].invoiceId,
                invoiceNum: this.state.finalCustommer[i].invoiceNum,
                totalAmount: this.state.finalCustommer[i].totalAmount,
                payableAmount: this.state.finalCustommer[i].payableAmount,
                address: this.state.finalCustommer[i].address,
                geo: {
                  title: this.state.finalCustommer[i].geo.title
                },
                buyerName: this.state.finalCustommer[i].buyerName,
                checked: true
              }

              var index = this.state.concatData.findIndex(
                (concatData) => concatData.deliveryPackId === positionObject.deliveryPackId
              )

              this.setState((prevState) => {
                let newpoints = this.state.concatData
                newpoints[index].checked = positionObject.checked
                return {
                  concatData: newpoints
                }
              })
            }
          } else if (response.data.error == 'EMPTY_RESULTS') {
            message.error('در این ناحیه سفارشی موجود نیست')
          } else {
            message.error(response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else {
      message.error('ابتدا ناحیه را مشخص کنید')
    }
  }

  convertState = (x) => {
    if (x == -100) {
      x = 'کنسل'
      return x
    } else if (x == -75) {
      x = 'مرجوعی'
      return x
    } else if (x == -50) {
      x = 'بازگشتی'
      return x
    } else if (x == -25) {
      x = 'تخصیص مجدد'
      return x
    } else if (x == -1) {
      x = 'تخصیص داده نشده'
      return x
    } else if (x === 1) {
      x = 'فعال'
      return x
    } else if (x == 5) {
      x = 'اول فعال'
      return x
    } else if (x == 10) {
      x = 'شروع شده'
      return x
    } else if (x == 18) {
      x = 'تسویه نشده'
      return x
    } else if (x == 20) {
      x = 'تسویه شده'
      return x
    }
  }

  addCustomer = (rowId) => {
    let id = rowId.index
    const positionObject = {
      deliveryPackId: this.state.concatData[id].deliveryPackId,
      invoiceId: this.state.concatData[id].invoiceId,
      invoiceNum: this.state.concatData[id].invoiceNum,
      totalAmount: this.state.concatData[id].totalAmount,
      geo: {
        title: this.state.concatData[id].geo.title
      },
      payableAmount: this.state.concatData[id].payableAmount,
      address: this.state.concatData[id].address,
      buyerName: this.state.concatData[id].buyerName,
      checked: true
    }

    this.setState((prevState) => {
      let newpoints = this.state.concatData
      newpoints[id].checked = positionObject.checked
      return {
        concatData: newpoints
      }
    })

    const isFound = this.state.finalCustommer.find(
      (custommer) => custommer.deliveryPackId === positionObject.deliveryPackId
    )
    if (!isFound) {
      this.setState((prevState) => ({
        finalCustommer: [...prevState.finalCustommer, positionObject],
        openTable: true
      }))
    } else {
      message.error('این مشتری قبلا به لیست اضافه شده است')
    }
  }

  removeCustomer = (rowId) => {
    let id = rowId.index
    const positionObject = {
      deliveryPackId: this.state.concatData[id].deliveryPackId,
      invoiceId: this.state.concatData[id].invoiceId,
      invoiceNum: this.state.concatData[id].invoiceNum,
      totalAmount: this.state.concatData[id].totalAmount,
      geo: {
        title: this.state.concatData[id].geo.title
      },
      payableAmount: this.state.concatData[id].payableAmount,
      address: this.state.concatData[id].address,
      buyerName: this.state.concatData[id].buyerName,
      checked: false
    }

    this.setState((prevState) => {
      let newpoints = this.state.concatData
      newpoints[id].checked = positionObject.checked
      return {
        concatData: newpoints
      }
    })

    var index = this.state.finalCustommer.findIndex(
      (concatData) => concatData.deliveryPackId === positionObject.deliveryPackId
    )
    this.state.finalCustommer.splice(index, 1)
    this.setState(this.state.finalCustommer)
    // if (this.state.custommer.length == '0') {
    //     this.setState({
    //         openTable: false
    //     })
    // }
  }

  delete = (rowId) => {
    this.setState({
      disabledSelect: true
    })

    const positionObject = {
      deliveryPackId: this.state.finalCustommer[rowId].deliveryPackId,
      invoiceId: this.state.finalCustommer[rowId].invoiceId,
      invoiceNum: this.state.finalCustommer[rowId].invoiceNum,
      totalAmount: this.state.finalCustommer[rowId].totalAmount,
      payableAmount: this.state.finalCustommer[rowId].payableAmount,
      address: this.state.finalCustommer[rowId].address,
      buyerName: this.state.finalCustommer[rowId].buyerName,
      checked: false
    }

    var index = this.state.concatData.findIndex(
      (concatData) => concatData.deliveryPackId === positionObject.deliveryPackId
    )

    this.setState((prevState) => {
      let newpoints = this.state.concatData
      // alert(JSON.stringify(newpoints[index]))
      newpoints[index].checked = positionObject.checked
      return {
        points: newpoints
      }
    })

    this.state.finalCustommer.splice(rowId, 1)
    this.setState(this.state.finalCustommer)
  }

  deleteAllCustomer() {
    for (let id = 0; id < this.state.concatData.length; id++) {
      const positionObject = {
        deliveryPackId: this.state.concatData[id].deliveryPackId,
        invoiceId: this.state.concatData[id].invoiceId,
        invoiceNum: this.state.concatData[id].invoiceNum,
        totalAmount: this.state.concatData[id].totalAmount,
        geo: {
          title: this.state.concatData[id].geo.title
        },
        payableAmount: this.state.concatData[id].payableAmount,
        address: this.state.concatData[id].address,
        buyerName: this.state.concatData[id].buyerName,
        checked: false
      }

      this.setState((prevState) => {
        let newpoints = this.state.concatData
        newpoints[id].checked = positionObject.checked
        return {
          concatData: newpoints
        }
      })
    }

    this.setState({
      finalCustommer: []
    })
  }

  Up = (rowId) => {
    if (rowId > 0) {
      let temp = this.state.finalCustommer[rowId - 1]
      this.state.finalCustommer[rowId - 1] = this.state.finalCustommer[rowId]
      this.state.finalCustommer[rowId] = temp
      this.setState(this.state.finalCustommer)
    }
  }
  Down = (rowId) => {
    if (rowId < this.state.finalCustommer.length - 1) {
      let temp = this.state.finalCustommer[rowId + 1]
      this.state.finalCustommer[rowId + 1] = this.state.finalCustommer[rowId]
      this.state.finalCustommer[rowId] = temp
      this.setState(this.state.finalCustommer)
    }
  }

  handleMarkerClick = (
    index,
    deliveryPackId,
    invoiceId,
    invoiceNum,
    totalAmount,
    payableAmount,
    Address,
    geoTitle,
    buyerName
  ) => {
    let positionObject = {
      deliveryPackId: deliveryPackId,
      invoiceId: invoiceId,
      invoiceNum: invoiceNum,
      totalAmount: totalAmount,
      payableAmount: payableAmount,
      address: Address,
      geo: {
        title: geoTitle
      },
      buyerName: buyerName,
      checked: true
    }

    this.setState((prevState) => {
      let newpoints = this.state.concatData
      newpoints[index].checked = positionObject.checked
      return {
        concatData: newpoints
      }
    })
    const isFound = this.state.finalCustommer.find(
      (custommer) => custommer.deliveryPackId === positionObject.deliveryPackId
    )
    if (!isFound) {
      this.setState((prevState) => ({
        finalCustommer: [...prevState.finalCustommer, positionObject],
        openTable: true
      }))
    } else {
      message.error('این مشتری قبلا به لیست اضافه شده است')
    }
  }

  Sort() {
    let {finalCustommer} = this.state
    const token = sessionStorage.getItem('accessToken')

    for (var a = 0; a < finalCustommer.length; a++) {
      this.state.packId.push(finalCustommer[a]['deliveryPackId'])
    }
    var sortData = {
      deliveryPackIds: this.state.packId
    }

    http
      .post(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_SORT}`, sortData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            finalCustommer: response.data.object.result
          })
        } else if (response.data.error == 'EMPTY_RESULTS') {
          message.error('سفارشی ارسال نشده است')
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  submit(e) {
    e.preventDefault()
  }

  edit() {
    let {finalCustommer} = this.state
    const {dispatchId} = this.props.match.params
    var planId = this.props.match.params.planId

    for (var a = 0; a < finalCustommer.length; a++) {
      if (!(finalCustommer[a]['lastState'] == '20')) {
        this.state.packId.push(finalCustommer[a]['deliveryPackId'])
      }
    }
    const editDate = {
      dispatchId: dispatchId,
      deliveryPackIds: this.state.packId
    }
    this.setState({
      setAssign: true
    })

    // alert(JSON.stringify(editDate))
    http
      .post(`${RETAIL.RETAIL_COMPANY_PLAN_EDIT_DELIVERYPACK}`, editDate, {})
      .then((response) => {
        if (response.data.error == null) {
          message.success('ویرایش سفارش ها با موفقیت انجام شد')

          this.setState(
            {
              failedToDispatchIds:
                response.data.object.failedToDispatchIds === null ? [] : response.data.object.failedToDispatchIds,
              failedToProcessIds:
                response.data.object.failedToProcessIds === null ? [] : response.data.object.failedToProcessIds,
              setAssign: false
            },
            () => {
              if (this.state.failedToDispatchIds.length > 0 || this.state.failedToProcessIds.length > 0) {
                this.setState({
                  unMatchModal: true
                })
              } else {
                this.updatePage()
              }
            }
          )
        } else {
          this.setState({
            packId: []
          })
          // message.error(response.data.description)
        }
      })
      .catch((error) => {
        this.setState({
          packId: [],
          setAssign: false
        })
        // alert(JSON.stringify(error))
      })
  }

  updatePage = () => {
    let {finalCustommer} = this.state
    const {dispatchId} = this.props.match.params
    var planId = this.props.match.params.planId

    this.setState({
      packId: [],
      unMatchModal: false,
      loading: true
    })
    setTimeout(() => {
      location.reload()
    }, 2000)
  }

  compareBy(key) {
    return function(a, b) {
      if (a[key] < b[key]) return -1
      if (a[key] > b[key]) return 1
      return 0
    }
  }

  sortBy(key) {
    // alert(key)
    let arrayCopy = this.state.concatData
    arrayCopy.sort(this.compareBy(key))
    this.setState({data: arrayCopy})
  }

  unAssigned = (params) => {
    let planId = this.props.match.params.planId
    let geoId = document.getElementById('geoId').value

    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_UNASSIGNED}?planId=${planId}&geoId=${geoId}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var points = response.data.object.result
          for (let i = 0; i < points.length; i++) {
            points[i]['checked'] = false
            points[i]['geoTitle'] = points[i]['geo'].title
          }

          this.setState({
            points: response.data.object.result,
            concatData: response.data.object.result.concat(params)
          })

          for (let i = 0; i < this.state.finalCustommer.length; i++) {
            const positionObject = {
              deliveryPackId: this.state.finalCustommer[i].deliveryPackId,
              invoiceId: this.state.finalCustommer[i].invoiceId,
              invoiceNum: this.state.finalCustommer[i].invoiceNum,
              totalAmount: this.state.finalCustommer[i].totalAmount,
              payableAmount: this.state.finalCustommer[i].payableAmount,
              address: this.state.finalCustommer[i].address,
              buyerName: this.state.finalCustommer[i].buyerName,
              checked: true
            }
            var index = this.state.points.findIndex((points) => points.deliveryPackId === positionObject.deliveryPackId)

            if (index >= 0) {
              this.setState((prevState) => {
                let newpoints = this.state.points
                newpoints[index].checked = positionObject.checked
                return {
                  points: newpoints
                }
              })
            }
          }
        } else {
          this.setState({
            points: [],
            concatData: [].concat(params)
          })
        }
      })
  }

  filter() {
    let {dispatchId, driverId} = this.props.match.params
    let planId = this.props.match.params.planId
    let geoId = document.getElementById('geoId').value
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_ASSIGNED_BYEDIT
        }?export=true&planId=${planId}&dispatchId=${dispatchId}&driverId=${driverId}&geoId=${geoId}`,
        {}
      )
      .then((response) => {
        this.setState({
          concatData: [],
          points: []
        })

        if (response.data.error == null) {
          var custommer = response.data.object.result
          for (let i = 0; i < custommer.length; i++) {
            custommer[i]['checked'] = true
          }
          if (geoId == '') {
            this.setState({
              finalCustommer: response.data.object.result
            })
          }
          this.setState({
            custommer: response.data.object.result
          })

          this.unAssigned(response.data.object.result)
        } else {
          this.setState({
            custommer: []
          })
          this.unAssigned([])
        }
      })
  }

  getMarkers() {
    let points = this.state.concatData
    const array = []
    points.forEach((item) => {
      if (item.latitude && item.longitude) {
        array.push({
          location: [item.latitude, item.longitude],
          ...item
        })
      }
    })
    return array
  }

  selectCustomer = (item, index) => {
    let positionObject = {
      deliveryPackId: item.deliveryPackId,
      invoiceId: item.invoiceId,
      invoiceNum: item.invoiceNum,
      totalAmount: item.totalAmount,
      payableAmount: item.payableAmount,
      address: item.address,
      geo: {
        title: item.geoTitle
      },
      buyerName: item.buyerName,
      checked: true
    }

    this.setState((prevState) => {
      let newpoints = this.state.concatData
      newpoints[index].checked = positionObject.checked
      return {
        concatData: newpoints
      }
    })
    const isFound = this.state.finalCustommer.find(
      (custommer) => custommer.deliveryPackId === positionObject.deliveryPackId
    )
    if (!isFound) {
      this.setState((prevState) => ({
        finalCustommer: [...prevState.finalCustommer, positionObject],
        openTable: true
      }))
    } else {
      message.error('این مشتری قبلا به لیست اضافه شده است')
    }
  }

  render() {
    const {points} = this.state
    const unSelected = renderToStaticMarkup(<img src={require('../../image/requestPack.png')} />)
    const selected = renderToStaticMarkup(<img src={require('../../image/finishPack.png')} />)
    const {name} = this.props.match.params

    const classTable = this.state.openTable ? 'appointedCustommer' : 'appointedCustommer hide'

    var initialVal = 0
    var sumUnassigned = this.state.concatData.reduce(function(acc, current) {
      return Number(acc) + Number(current.payableAmount)
    }, initialVal)

    return (
      <div className="rtl body">
        <Loader show={this.state.loading} />

        {/*<AdminMenu/>*/}
        <div className="Packs wrapperIframe">
          {/* <div className="titlePacks">
            <h5>لیست همه فاکتور ها</h5>
            <div className="btnMap">
              <button
                className="setPolygon btn btn-sm"
                onClick={this.confirmPoly.bind(this)}
              >
                تایید چند ضلعی
              </button>
            </div>
          </div> */}

          <div className="addressMap">
            <Map center={[35.6892, 51.389]} zoom={10} style={{height: '500px'}}>
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              {this.getMarkers().map((item, index) => (
                <Marker
                  icon={
                    item.checked
                      ? divIcon({
                          html: selected,
                          iconSize: [30, 30],
                          iconAnchor: [10, 38]
                        })
                      : divIcon({
                          html: unSelected,
                          iconSize: [30, 30],
                          iconAnchor: [10, 38]
                        })
                  }
                  position={item.location}
                  title={item.buyerName + '- شماره فاکتور : ' + item.invoiceNum}
                  onClick={() => this.selectCustomer(item, index)}
                >
                  {/* <Popup>
                                            <p className="text-center">{item.driverInfo.name}</p>
                                            <p>
                                            ساعت :‌
                                            {"  " + item.location.timestamp &&
                                                jMoment(item.location.timestamp).format(
                                                "jYYYY/jMM/jDD HH:mm:ss"
                                                )}
                                            </p>
                                        </Popup> */}
                </Marker>
              ))}
            </Map>
          </div>

          {/* <MapWithAMarker
                        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDh3yzsorXDyP-gAlxEGUlzmfJ6nVxizUw&v=3.exp&libraries=geometry,drawing,places"
                        loadingElement={<div style={{ height: `100%` }} />}
                        containerElement={<div style={{ height: `400px` }} />}
                        mapElement={<div style={{ height: `100%` }} />}
                        onMarkerClick={this.handleMarkerClick}
                        points={this.state.concatData}
                    /> */}

          <div className="basketFilterComponent" style={{marginTop: '30px'}}>
            <div className="filterInputs">
              <div className="formComponent">
                <label>منطقه شهرداری :</label>
                <select disabled={this.state.disabledSelect} className="form-control" id="geoId" name="geoId">
                  <option value="">------</option>
                  {this.state.listGeo.map((geo, index) => (
                    <option value={geo.id}>{geo.title}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="filterOption">
              <button disabled={this.state.disabledSelect} className="confirmFilter" onClick={this.filter.bind(this)}>
                جست و جو
              </button>
            </div>
          </div>
          <table className="baseTable">
            <tr className="firstRow">
              <td>ردیف</td>
              <td>شناسه</td>

              <td onClick={() => this.sortBy('invoiceId')}>
                شناسه فاکتور{' '}
                <span>
                  <img className="filterImage" src={require('../../image/filterTable.svg')} />{' '}
                </span>
              </td>
              <td onClick={() => this.sortBy('invoiceNum')}>
                شماره فاکتور{' '}
                <span>
                  <img className="filterImage" src={require('../../image/filterTable.svg')} />{' '}
                </span>
              </td>
              <td onClick={() => this.sortBy('payableAmount')} className="priceCell">
                {' '}
                قابل پرداخت (ریال)
                <span>
                  <img className="filterImage" src={require('../../image/filterTable.svg')} />{' '}
                </span>
              </td>
              <td onClick={() => this.sortBy('geoTitle')}>
                {' '}
                منطقه{' '}
                <span>
                  <img className="filterImage" src={require('../../image/filterTable.svg')} />{' '}
                </span>
              </td>
              <td>آدرس</td>
              <td>موقعیت روی نقشه</td>
              <td>خریدار</td>
              <td>جزییات</td>
              <td>درج</td>
            </tr>
            {this.state.concatData.map((items, index) => (
              <tr style={items.checked ? {backgroundColor: '#efffae'} : {backgroundColor: '#fff'}}>
                <td>{index + 1}</td>
                <td>{items.deliveryPackId}</td>
                <td>{items.invoiceId}</td>
                <td>{items.invoiceNum}</td>
                <td className="priceCell">{accounting.formatMoney(items.payableAmount, '', ',')}</td>
                <td>{items.geo.title}</td>
                <td>{items.address}</td>
                <td>{items.latitude == null ? 'ندارد' : 'دارد'}</td>

                <td>{items.buyerName}</td>
                <td>
                  <Link to={`/subFactors/${items.deliveryPackId}`} target="_blank">
                    <img src={require('../../image/details.svg')} />
                  </Link>
                </td>
                <td>
                  <button
                    onClick={() => this.addCustomer({index})}
                    style={items.checked ? {display: 'none'} : {display: 'block'}}
                  >
                    <img src={require('../../image/add.svg')} />
                  </button>

                  <button
                    onClick={() => this.removeCustomer({index})}
                    style={items.checked ? {display: 'block'} : {display: 'none'}}
                  >
                    <img src={require('../../image/minus.svg')} />
                  </button>
                </td>
              </tr>
            ))}
            <tr>
              <td colSpan={4}>مجموع</td>
              <td className="priceCell">{accounting.formatMoney(sumUnassigned, '', ',')}</td>
              <td colSpan={6} />
            </tr>
          </table>
        </div>
        <div className="Packs wrapperIframe">
          <div className={classTable}>
            <div className="titlePacks">
              <h5>{'فاکتور های انتخاب شده برای ' + name}</h5>
              <div className="btnMap">
                <button className="setPolygon btn btn-sm" onClick={this.Sort.bind(this)}>
                  مرتب سازی لیست
                </button>
                <button className="cancelPolygon btn  btn-sm" onClick={this.deleteAllCustomer.bind(this)}>
                  حذف لیست
                </button>
              </div>
            </div>
            <table className="baseTable">
              <tr className="firstRow">
                <td>ردیف</td>
                <td>شناسه</td>
                <td>شناسه فاکتور</td>
                <td>شماره فاکتور</td>

                <td className="priceCell">قیمت قابل پرداخت</td>
                <td>منطقه</td>
                <td>آدرس</td>
                <td> خریدار</td>
                <td>جزییات</td>
                <td>حالت</td>
                <td>بالا</td>
                <td>پایین</td>
                <td>حذف</td>
              </tr>
              {this.state.finalCustommer.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.deliveryPackId}</td>
                  <td>{item.invoiceId}</td>
                  <td>{item.invoiceNum}</td>
                  <td className="priceCell">{accounting.formatMoney(item.payableAmount, '', ',')}</td>
                  <td>{item.geo.title}</td>
                  <td>{item.address}</td>
                  <td>{item.buyerName}</td>
                  <td>
                    <Link to={`/subFactors/${item.deliveryPackId}`} target="_blank">
                      <img src={require('../../image/details.svg')} />
                    </Link>
                  </td>
                  <td>{this.convertState(item.lastState)}</td>
                  <td>
                    <button>
                      <img src={require('../../image/up.svg')} onClick={() => this.Up(index)} />
                    </button>
                  </td>
                  <td>
                    <button>
                      <img src={require('../../image/down.svg')} onClick={() => this.Down(index)} />
                    </button>
                  </td>
                  <td>
                    <button onClick={() => this.delete(index)}>
                      <img
                        style={item.lastState == '20' ? {display: 'none'} : {display: 'block'}}
                        src={require('../../image/trash.svg')}
                      />
                    </button>
                  </td>
                </tr>
              ))}
            </table>
            <form className="assignForm" onSubmit={this.submit.bind(this)}>
              <button
                className="btn btn-primary btn-sm"
                disabled={this.state.setAssign ? true : false}
                onClick={this.edit.bind(this)}
              >
                ویرایش
              </button>
              <p className="errorText">{this.state.editError}</p>
            </form>
          </div>
        </div>
        <Modal isOpen={this.state.unMatchModal} toggle={() => this.updatePage()}>
          {this.state.failedToDispatchIds.length > 0 && (
            <ModalBody className="d-flex flex-column justify-content-center align-content-center align-items-center">
              <h3 className="text-center font-weight-bold">
                لیست مرسوله هایی که وضعیتشان به دریافت در مرکز توزیع تغییر نکرده است.
              </h3>
              <table className="baseTable">
                <tr className="firstRow" style={{fontSize: '2em'}}>
                  <th>ردیف</th>
                  <th>شماره مرسوله</th>
                </tr>
                {this.state.failedToDispatchIds.map((item, index) => (
                  <tr style={{fontSize: '2em'}}>
                    <th>{index + 1}</th>
                    <th>
                      <a href={`http://192.168.7.10:9090/parcels/info/${item}`} target="_blank">
                        {item}
                      </a>
                    </th>
                  </tr>
                ))}
              </table>
            </ModalBody>
          )}
          {this.state.failedToProcessIds.length > 0 && (
            <ModalBody className="d-flex flex-column justify-content-center align-content-center align-items-center">
              <h3 className="text-center font-weight-bold">
                لیست مرسوله هایی که وضعیتشان به در حال پردازش تغییر نکرده است.
              </h3>
              <table className="baseTable">
                <tr className="firstRow" style={{fontSize: '2em'}}>
                  <th>ردیف</th>
                  <th>شماره مرسوله</th>
                </tr>
                {this.state.failedToProcessIds.map((item, index) => (
                  <tr style={{fontSize: '2em'}}>
                    <th>{index + 1}</th>
                    <th>
                      <a href={`http://192.168.7.10:9090/parcels/info/${item}`} target="_blank">
                        {item}
                      </a>
                    </th>
                  </tr>
                ))}
              </table>
            </ModalBody>
          )}
        </Modal>
      </div>
    )
  }
}

export default EditFactorDrivers
